module.exports = __webpack_public_path__ + "img/close.0175daf1.svg";